import script from "./equipment-details.vue?vue&type=script&setup=true&lang=ts"
export * from "./equipment-details.vue?vue&type=script&setup=true&lang=ts"

import "./equipment-details.vue?vue&type=style&index=0&id=e0af4310&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0af4310"]])

export default __exports__